import styled from 'styled-components'
import { colors } from 'theme/default'
import { LinkText } from 'components/Typo'

const LinkButton = styled(LinkText)`
  text-decoration: ${props => props.underline ? 'underline' : 'none'};

  &:focus {
    outline: none;
  }

  ${props => props.disabled ? `
    color: ${colors.text};
    pointer-events: none;
    cursor: default;

    &:hover {
      color: ${colors.text};
    }

    &:focus {
    outline: none;
     }

  ` : ''}
`

export default LinkButton
